// @flow
export const isPending = (state: Object): boolean => state.leagues.show.is_pending;

export const getError = (state: Object) => state.leagues.show.error;